import { useQuery } from "@apollo/client"
import moment from "moment"
import { FC, useContext, useState } from "react"
import { Controller } from "react-hook-form"
import Select from "react-select"
import { Col, FormGroup, Input, Label, Row } from "reactstrap"
import { AppContext } from "../../../../context"
import { BasicInformationProps } from "../../../../interfaces"
import { GET_RECRUITER_LIST } from "../../../../Pages/job-order/gql"
import { priceHandler } from "../../../../utils/helper"
import { customSelectStyleNew } from "../../../styled/customSelect"

const BasicInformation: FC<BasicInformationProps> = ({ recruiterId, recruiterDeal, getValues, control, setNonRecoverable, setUnderTraining,
  nonRecoverable, underTraining, errors, register, setValue }) => {
  const [mentorsList, setMentorsList] = useState<{ label: string, value: string }[]>([]);
  const { theme } = useContext(AppContext)

  // query and mutations
  const { loading } = useQuery(GET_RECRUITER_LIST, {
    onCompleted: (data) => setMentorsList(data?.getRecruiterList?.filter(({ id }) => id !== recruiterId).map(({ id, fullName }) => { return { label: fullName, value: id } }))
  })

  // if (loading) {
  //   return <Loader />
  // }

  return <Row >

    <Col sm='6' className="mb-3 custom-form-input form-input">
      <Label className="text-14 text-blackele pb-2">Deal Name <span className="text-danger">*</span></Label>
      <Controller
        name="dealName"
        rules={{ required: { value: true, message: "Deal Name is a required field" } }}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            defaultValue={recruiterDeal?.dealName}
            placeholder="Enter deal name"
            type="text"
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.dealName?.message as React.ReactNode}
      </small>
    </Col>

    <Col sm='6' className="mb-3 custom-form-input form-input">
      <Label className="text-14 text-blackele pb-2">Title <span className="text-danger">*</span></Label>
      <Controller
        name="recruiterTitle"
        rules={{ required: { value: true, message: "Title is a required field" } }}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            defaultValue={recruiterDeal?.recruiterTitle}
            placeholder="Enter title"
            type="text"
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.recruiterTitle?.message as React.ReactNode}
      </small>
    </Col>

    <Col xs='6' className="mb-4 custom-form-input form-input">
      <Label className="text-14 text-blackele pb-2">Deal Start Date <span className="text-danger">*</span> </Label>
      <Controller
        rules={{ required: { value: true, message: "Deal Start Date is a required field" } }}
        name="dealStartDate"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            defaultValue={recruiterDeal?.dealStartDate}
            placeholder="Select Date"
            type="date"
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.dealStartDate?.message as React.ReactNode}
      </small>
    </Col>
    <Col xs='6' className="mb-4 custom-form-input form-input">
      <Label className="text-14 text-blackele pb-2">Deal End Date </Label>
      <Controller
        name="dealEndDate"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            defaultValue={recruiterDeal?.dealEndDate}
            placeholder="Select Date"
            type="date"
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.dealEndDate?.message as React.ReactNode}
      </small>
    </Col>

    <Col sm='6' className="mb-3">
      <Label className="text-14 text-blackele pb-2">Assign Mentor</Label>
      <Controller
        name="assignedManagerId"
        control={control}
        defaultValue={recruiterDeal?.assignedManagerId && { value: recruiterDeal?.assignedManagerId, label: recruiterDeal?.assignedManager?.fullName }}
        rules={{ required: { value: false, message: "Assign Mentor is a required field" } }}
        render={({ field: { onChange, value } }) => (
          <Select
            value={value}
            isLoading={loading}
            isDisabled={loading}
            options={mentorsList}
            onChange={(val) => {
              onChange(val);
              setValue('assignedManagerId', val);
            }}
            styles={{ ...customSelectStyleNew(theme) }}
            placeholder="Select Mentor"
          />
        )}
      />
      <div className="d-flex align-items-end curser-pointer flex-column my-1 px-2"
        onClick={() => {
          setValue("assignedManagerId", null)
          setValue("mentorCommission", '0 %')
        }}>
        <small className="titile-count-message-color" >Clear</small>
      </div>
      <small className="text-danger pt-2">
        {errors?.assignedManagerId?.message as React.ReactNode}
      </small>
    </Col>

    <Col sm='6' className="mb-3 custom-form-input form-input">
      <Label className="text-14 text-blackele pb-2">Mentor Commission</Label>
      <Controller
        name="mentorCommission"
        defaultValue={recruiterDeal?.mentorCommission}
        rules={{ required: { value: false, message: "Mentor Commission is a required field" } }}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            placeholder="Mentor Percentage"
            type="text"
            onChange={({ target: { value } }) => {
              const filteredValue = value.replace(/,/g, '').replace(/[^\d.]/g, "").replace(/^\./, "0.")
              const newValue = filteredValue.slice(0, 4);
              field.onChange(newValue);
              setValue("mentorCommission", newValue);
            }}
            onFocus={(value) => value.target.value && setValue("mentorCommission", value.target.value.replaceAll(" %", ""))}
            onBlur={(value) => value.target.value && setValue("mentorCommission", value.target.value + " %")}
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.mentorCommission?.message as React.ReactNode}
      </small>
    </Col>

    <Col xs='12' className="mb-4 custom-form-input form-input">
      <div className="d-flex align-items-center">
        <span className="switchLabel">Recoverable Draw</span>
        <label className="switch m-0 mx-2">
          <Controller
            control={control}
            name="nonRecoverableDraw"
            render={({ field }) => (
              <Input
                checked={field.value === true}
                onChange={(e) => {
                  field.onChange(e.target.checked);
                  setNonRecoverable(e.target.checked);
                }}
                type="checkbox"
              />
            )}
          />
          <span className="slider"></span>
        </label>
        <span className="switchLabel">Non Recoverable Draw</span>
      </div>
    </Col>

    <Col sm='6' className="mb-3 custom-form-input form-input">
      <Label className="text-14 text-blackele pb-2">Recruiter Draw Percentage <span className="text-danger">*</span></Label>
      <Controller
        name="drawPercentage"
        rules={{ required: { value: true, message: "Recruiter Draw Percentage is a required field" } }}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            defaultValue={recruiterDeal?.drawPercentage?.replaceAll(" ", "")}
            placeholder="100%"
            type="text"
            onChange={({ target: { value } }) => {
              const filteredValue = value.replace(/,/g, '').replace(/[^\d.]/g, "").replace(/^\./, "0.")
              const newValue = filteredValue.slice(0, 4);
              field.onChange(newValue);
              setValue("drawPercentage", newValue)
            }}
            onFocus={(value) => value.target.value && setValue("drawPercentage", value.target.value.replaceAll("%", "").replaceAll(" ", ""))}
            onBlur={(value) => value.target.value && setValue("drawPercentage", value.target.value + "%")}
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.drawPercentage?.message as React.ReactNode}
      </small>
    </Col>

    <Col sm='6' className="mb-3 custom-form-input form-input">
      <Label className="text-14 text-blackele pb-2">Bi-Weekly Draw <span className="text-danger">*</span></Label>
      <Controller
        name="biWeeklySalary"
        control={control}
        rules={{ required: { value: true, message: "Bi-Weekly Draw is a required field" } }}
        render={({ field }) => (
          <Input
            {...field}
            defaultValue={recruiterDeal?.biWeeklySalary}
            placeholder="Amount"
            type="text"
            onChange={({ target: { value } }) => {
              const filteredValue = value.replace(/,/g, '').replace(/\D/g, "")
              const newValue = priceHandler(filteredValue);
              field.onChange(newValue);
              setValue("biWeeklySalary", newValue)
            }}
            onFocus={(value) => value.target.value && setValue("biWeeklySalary", value.target.value.replaceAll("$ ", ""))}
            onBlur={(value) => value.target.value && setValue("biWeeklySalary", "$ " + value.target.value)}
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.biWeeklySalary?.message as React.ReactNode}
      </small>
    </Col>

    <Col sm='6' className="mb-3 custom-form-input form-input">
      <Label className="text-14 text-blackele pb-2">Direct Hire Base Rate <span className="text-danger">*</span></Label>
      <Controller
        name="dhBaseRate"
        rules={{ required: { value: true, message: "Direct Hire Base Rate is a required field" } }}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            defaultValue={recruiterDeal?.dhBaseRate?.replaceAll(" ", "")}
            placeholder="25 % "
            type="text"
            onChange={({ target: { value } }) => {
              const filteredValue = value.replace(/,/g, '').replace(/[^\d.]/g, "").replace(/^\./, "0.")
              const newValue = filteredValue.slice(0, 4);
              field.onChange(newValue);
              setValue("dhBaseRate", newValue)
            }}
            onFocus={(value) => value.target.value && setValue("dhBaseRate", value.target.value.replaceAll("%", "").replaceAll(" ", ""))}
            onBlur={(value) => value.target.value && setValue("dhBaseRate", value.target.value + "%")}
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.dhBaseRate?.message as React.ReactNode}
      </small>
    </Col>

    <Col sm='6' className="mb-3 custom-form-input form-input">
      <Label className="text-14 text-blackele pb-2">Contracting Base Rate <span className="text-danger">*</span></Label>
      <Controller
        name="contractingBaseRate"
        rules={{ required: { value: true, message: "Contracting Base Rate is a required field" } }}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            defaultValue={recruiterDeal?.contractingBaseRate?.replaceAll(" ", "")}
            placeholder="25 %"
            type="text"
            onChange={({ target: { value } }) => {
              const filteredValue = value.replace(/,/g, '').replace(/[^\d.]/g, "").replace(/^\./, "0.")
              const newValue = filteredValue.slice(0, 4);
              field.onChange(newValue);
              setValue("contractingBaseRate", newValue)
            }}
            onFocus={(value) => value.target.value && setValue("contractingBaseRate", value.target.value.replaceAll("%", "").replaceAll(" ", ""))}
            onBlur={(value) => value.target.value && setValue("contractingBaseRate", value.target.value + "%")}
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.contractingBaseRate?.message as React.ReactNode}
      </small>
    </Col>

    <Col sm='6' className="mb-3 custom-form-input form-input">
      <Label className="text-14 text-blackele pb-2">New Client Bonus <span className="text-danger">*</span></Label>
      <Controller
        name="newClientBonus"
        rules={{ required: { value: true, message: "New Client Bonus is a required field" } }}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            defaultValue={recruiterDeal?.newClientBonus?.replaceAll(" ", "")}
            placeholder="25 %"
            type="text"
            onChange={({ target: { value } }) => {
              const filteredValue = value.replace(/,/g, '').replace(/[^\d.]/g, "").replace(/^\./, "0.")
              const newValue = filteredValue.slice(0, 4);
              field.onChange(newValue);
              setValue("newClientBonus", newValue)
            }}
            onFocus={(value) => value.target.value && setValue("newClientBonus", value.target.value.replaceAll("%", "").replaceAll(" ", ""))}
            onBlur={(value) => value.target.value && setValue("newClientBonus", value.target.value + "%")}
          />
        )}
      />
      <small className="text-danger pt-2">
        {errors?.newClientBonus?.message as React.ReactNode}
      </small>
    </Col>

  </Row >
}
export default BasicInformation